import '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import { InstrumentGetByNotationModuleFactory } from '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import { PricesListModuleFactory } from '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import { PortfolioPositionListModuleFactory } from '../../endpoints/portfolio/position/list.module.js';
import { PortfolioGetModuleFactory } from '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { getPercentage, mapAssetClass, convertMdg2DateTimeResponse, getLanguage, getEndpointOptions } from '../../helpers/common.js';
import 'lodash.set';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';

var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
class PortfolioPositionsTopFlopStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultLanguage = "en";
    this.nameType = (_d = (_c = (_b = (_a = this.options) == null ? void 0 : _a.instrument) == null ? void 0 : _b.name) == null ? void 0 : _c.type) != null ? _d : "name";
    this.isNameTypeFallbackEnabled = (_h = (_g = (_f = (_e = this.options) == null ? void 0 : _e.instrument) == null ? void 0 : _f.name) == null ? void 0 : _g.fallback) != null ? _h : true;
    this.quality = (_k = (_j = (_i = this.options) == null ? void 0 : _i.prices) == null ? void 0 : _j.quality) != null ? _k : "BST";
    this.sameQuality = (_n = (_m = (_l = this.options) == null ? void 0 : _l.prices) == null ? void 0 : _m.sameQuality) != null ? _n : false;
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  getResponseData(payload) {
    return {
      portfolio: {
        currency: this.getPortfolioCurrency(payload)
      },
      positions: this.getPositions(payload)
    };
  }
  getResponseMeta(payload) {
    var _a2;
    try {
      const unrealizedRelativePerformances = payload.valueBarRange === "relative" ? this.getRelativeRangeUnrealizedRelativePerformances(payload) : this.getAbsoluteRangeUnrealizedRelativePerformances(payload);
      const portfolioPositions = this.getPortfolioPositions(payload);
      const totalPortfolioPositions = (_a2 = portfolioPositions == null ? void 0 : portfolioPositions.length) != null ? _a2 : null;
      const paginationTotal = payload.maxItems && totalPortfolioPositions && totalPortfolioPositions > payload.maxItems ? payload.maxItems : totalPortfolioPositions;
      return {
        pagination: {
          total: paginationTotal
        },
        unrealizedPerformance: {
          minimum: unrealizedRelativePerformances ? getPercentage(Math.min(...unrealizedRelativePerformances)) : null,
          maximum: unrealizedRelativePerformances ? getPercentage(Math.max(...unrealizedRelativePerformances)) : null
        }
      };
    } catch (error) {
      return null;
    }
  }
  getRelativeRangeUnrealizedRelativePerformances(payload) {
    var _a2, _b2;
    try {
      return (_b2 = (_a2 = this.getPaginatedPortfolioPositions(payload)) == null ? void 0 : _a2.filter((position) => position.profitLoss.potential.relative !== null).map((position) => {
        var _a3;
        return Math.abs((_a3 = position.profitLoss.potential.relative) != null ? _a3 : NaN);
      })) != null ? _b2 : null;
    } catch (error) {
      return [];
    }
  }
  getAbsoluteRangeUnrealizedRelativePerformances(payload) {
    var _a2;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    return ((_a2 = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions) != null ? _a2 : []).filter((position) => position.profitLoss.potential.relative !== null).map((position) => {
      var _a3;
      return Math.abs((_a3 = position.profitLoss.potential.relative) != null ? _a3 : NaN);
    });
  }
  getPortfolioCurrency(payload) {
    var _a2;
    const portfolioData = this.getPortfolioGetData(payload);
    return (_a2 = portfolioData == null ? void 0 : portfolioData.currency.isoCode) != null ? _a2 : null;
  }
  getPaginatedPortfolioPositions(payload) {
    var _a2;
    const itemsLimit = payload.maxItems && payload.itemsPerPage > payload.maxItems ? payload.maxItems : payload.itemsPerPage;
    const portfolioPositions = this.getPortfolioPositions(payload);
    const sliceFrom = payload.pageOffset * payload.itemsPerPage;
    const sliceTo = payload.pageOffset + itemsLimit;
    return (_a2 = portfolioPositions == null ? void 0 : portfolioPositions.slice(sliceFrom, sliceTo)) != null ? _a2 : null;
  }
  getPositions(payload) {
    var _a2, _b2;
    try {
      return (_b2 = (_a2 = this.getPaginatedPortfolioPositions(payload)) == null ? void 0 : _a2.map((position) => this.getResponsePosition(payload, position))) != null ? _b2 : null;
    } catch (error) {
      return null;
    }
  }
  getPortfolioPositions(payload) {
    switch (payload.type) {
      case "top":
        return this.getPortfolioTopPositions(payload);
      case "flop":
        return this.getPortfolioFlopPositions(payload);
      case "gainers":
        return this.getPortfolioGainersPositions(payload);
      case "losers":
        return this.getPortfolioLosersPositions(payload);
      default:
        throw new Error("Invalid type given");
    }
  }
  getPortfolioTopPositions(payload) {
    var _a2;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    return (_a2 = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions.sort((a, b) => {
      var _a3, _b2;
      return ((_a3 = a.profitLoss.potential.relative) != null ? _a3 : NaN) > ((_b2 = b.profitLoss.potential.relative) != null ? _b2 : NaN) ? -1 : 1;
    })) != null ? _a2 : null;
  }
  getPortfolioFlopPositions(payload) {
    var _a2;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    return (_a2 = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions.sort((a, b) => {
      var _a3, _b2;
      return ((_a3 = a.profitLoss.potential.relative) != null ? _a3 : NaN) > ((_b2 = b.profitLoss.potential.relative) != null ? _b2 : NaN) ? 1 : -1;
    })) != null ? _a2 : null;
  }
  getPortfolioGainersPositions(payload) {
    var _a2;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    return (_a2 = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions.sort((a, b) => {
      var _a3, _b2;
      return ((_a3 = a.profitLoss.potential.relative) != null ? _a3 : NaN) > ((_b2 = b.profitLoss.potential.relative) != null ? _b2 : NaN) ? -1 : 1;
    }).filter((position) => position.profitLoss.potential.relative !== null && position.profitLoss.potential.relative > 0)) != null ? _a2 : null;
  }
  getPortfolioLosersPositions(payload) {
    var _a2;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    return (_a2 = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions.sort((a, b) => {
      var _a3, _b2;
      return ((_a3 = a.profitLoss.potential.relative) != null ? _a3 : NaN) > ((_b2 = b.profitLoss.potential.relative) != null ? _b2 : NaN) ? 1 : -1;
    }).filter((position) => position.profitLoss.potential.relative !== null && position.profitLoss.potential.relative < 0)) != null ? _a2 : null;
  }
  getNotationId(position) {
    if (!position.notation.id) {
      throw new Error("Could not get notation id");
    }
    return position.notation.id;
  }
  getResponsePosition(payload, position) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
    const instrumentGetData = this.getInstrumentGetByNotationData(payload, position);
    const priceData = this.getPricesListData(payload, position);
    const assetClass = mapAssetClass(instrumentGetData == null ? void 0 : instrumentGetData.assetClass.code);
    const nameFallback = this.isNameTypeFallbackEnabled ? (_a2 = instrumentGetData == null ? void 0 : instrumentGetData.name) != null ? _a2 : null : null;
    return {
      id: (_b2 = position.notation.id) != null ? _b2 : null,
      securityIdentifier: (_c2 = position.notation.id) != null ? _c2 : null,
      name: (_d2 = instrumentGetData == null ? void 0 : instrumentGetData[this.nameType]) != null ? _d2 : nameFallback,
      isin: (_e2 = position.instrument.isin) != null ? _e2 : null,
      lastPrice: (_f2 = priceData == null ? void 0 : priceData.latest.price) != null ? _f2 : null,
      lastPriceDateTime: convertMdg2DateTimeResponse((_g2 = priceData == null ? void 0 : priceData.latest.time) != null ? _g2 : null),
      currency: (_h2 = position.currency.isoCode) != null ? _h2 : null,
      quality: (_i2 = priceData == null ? void 0 : priceData.quality) != null ? _i2 : null,
      assetClass,
      unrealizedPerformance: (_j2 = position.profitLoss.potential.absolute) != null ? _j2 : null,
      unrealizedPerformanceRelative: getPercentage((_k2 = position.profitLoss.potential.relative) != null ? _k2 : null),
      weight: getPercentage(position.weight),
      marketValue: (_l2 = position.value) != null ? _l2 : null
    };
  }
  getNotationsIds(payload) {
    var _a2;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    const ids = [];
    for (const position of (_a2 = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions) != null ? _a2 : []) {
      try {
        ids.push(this.getNotationId(position));
      } catch (error) {
        continue;
      }
    }
    return ids;
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    try {
      await Promise.all([this.updatePortfolioGet(payload), this.updatePortfolioPositionList(payload)]);
      const ids = this.getNotationsIds(payload);
      await Promise.all([...ids.map(async (notationId) => this.updateInstrumentGetByNotation(payload, notationId)), this.updatePricesList(ids)]);
    } catch (error) {
      isResponseSuccessful = false;
      this.logger.error(error);
    }
    return isResponseSuccessful;
  }
  async updatePortfolioGet(payload) {
    const request = this.getPortfolioGetRequest(payload.id);
    return this.getEndpoints().portfolioGet.updateState(request);
  }
  getPortfolioGetData(payload) {
    var _a2;
    const request = this.getPortfolioGetRequest(payload.id);
    const response = this.getEndpoints().portfolioGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getPortfolioGetRequest(id) {
    return { id };
  }
  async updatePortfolioPositionList(payload) {
    const request = this.getPortfolioPositionListRequest(payload.id);
    return this.getEndpoints().portfolioPositionList.updateState(request);
  }
  getPortfolioPositionListData(payload) {
    var _a2;
    const request = this.getPortfolioPositionListRequest(payload.id);
    const response = this.getEndpoints().portfolioPositionList.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getPortfolioPositionListRequest(id) {
    return { id };
  }
  async updateInstrumentGetByNotation(payload, id) {
    const request = this.getInstrumentGetByNotationRequest(id, payload.language);
    return this.getEndpoints().instrumentGetByNotation.updateState(request);
  }
  getInstrumentGetByNotationData(payload, position) {
    var _a2;
    try {
      const notationId = this.getNotationId(position);
      const request = this.getInstrumentGetByNotationRequest(notationId, payload.language);
      const response = this.getEndpoints().instrumentGetByNotation.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getInstrumentGetByNotationRequest(id, payloadLanguage) {
    return { id, _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  async updatePricesList(ids) {
    const request = this.getPricesListRequest(ids);
    return this.getEndpoints().pricesList.updateState(request);
  }
  getPricesListRequest(identifiers) {
    return { identifiers, identifierType: "idNotation", quality: this.quality, sameQuality: this.sameQuality };
  }
  getPricesListData(payload, position) {
    var _a2;
    try {
      const notationId = this.getNotationId(position);
      const request = this.getPricesListNotationDataRequest(notationId);
      const response = this.getEndpoints().pricesList.getNotationData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getPricesListNotationDataRequest(id) {
    return { id, quality: this.quality, sameQuality: this.sameQuality };
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      this.endpoints = {
        portfolioGet: this.getModuleEntity(PortfolioGetModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioGet")),
        instrumentGetByNotation: this.getModuleEntity(InstrumentGetByNotationModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentGetByNotation")),
        portfolioPositionList: this.getModuleEntity(PortfolioPositionListModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioPositionList")),
        pricesList: this.getModuleEntity(PricesListModuleFactory, getEndpointOptions(endpointConfiguration, "pricesList"))
      };
    }
    return this.endpoints;
  }
}

export { PortfolioPositionsTopFlopStoreModuleFactory };
